import { createContext, useContext } from "react";

export const FormDetailContext = createContext(null);

export function useFormDetail() {
  const ctx = useContext(FormDetailContext);
  if (!ctx) {
    throw new Error("useFormDetail must be used within FormDetail");
  }
  return ctx;
}
